import { Link } from "@tanstack/react-router";
import type { ComponentPropsWithoutRef } from "react";

import { t } from "@/i18n-js/instance";
import { Badge } from "@/react/components/SettingsApp/CompassCompat/Badge";

export interface SubNavLinkItemProps extends ComponentPropsWithoutRef<
  typeof Link
> {
  badgeLabel?: string;
  exact?: boolean;
  isBetaFeature?: boolean;
  isDisabled?: boolean;
  isNewFeature?: boolean;
  label: string;
}

export const SubNavLinkItem = ({
  label,
  isNewFeature = false,
  isDisabled = false,
  isBetaFeature = false,
  exact = true,
  badgeLabel = "",
  ...props
}: SubNavLinkItemProps) => {
  if (isDisabled) {
    return null;
  }

  return (
    <Link
      activeOptions={{ exact, includeSearch: false }}
      className="hover:bg-secondary text-default hover:text-selector-active focus:text-selector-active flex items-center justify-between rounded-md px-2 py-1.5 text-sm font-medium leading-5 transition-colors duration-150 ease-linear"
      activeProps={{
        className: "bg-tertiary text-selector-active",
      }}
      {...props}
    >
      {label}
      {isNewFeature && <Badge label={t("new")} square variant="secondary" />}
      {isBetaFeature && <Badge label={t("beta")} square variant="secondary" />}
      {badgeLabel && (
        <Badge inverted label={badgeLabel} square variant="secondary" />
      )}
    </Link>
  );
};
